module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0154.jpg?v=a9c7b0c4";